module.exports = "/images/vendor/lightgallery/src/loading.gif?bbdac9cda255c54bfd809110aff87898";